import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-12" }
const _hoisted_5 = { class: "space-y-8" }
const _hoisted_6 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_10 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_12 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_13 = { class: "space-y-4" }
const _hoisted_14 = { class: "space-y-3" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "text-sm text-red-500 mt-2 flex items-center"
}
const _hoisted_18 = { class: "space-y-3" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-red-500 mt-2 flex items-center"
}
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-red-500 mt-2 flex items-center"
}
const _hoisted_23 = {
  key: 2,
  class: "text-sm text-green-600 mt-2 flex items-center"
}
const _hoisted_24 = { class: "space-y-8" }
const _hoisted_25 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_26 = { class: "space-y-4" }
const _hoisted_27 = { class: "flex items-center p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_28 = ["checked"]
const _hoisted_29 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-white rounded-lg border border-gray-200"
}
const _hoisted_30 = { class: "relative" }
const _hoisted_31 = ["aria-label"]
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = ["aria-label"]
const _hoisted_34 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_35 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_36 = { class: "space-y-3" }
const _hoisted_37 = { class: "flex items-center p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = { class: "flex items-center p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_40 = ["checked"]
const _hoisted_41 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_42 = { class: "flex items-center gap-2 p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_43 = { class: "bg-white p-6 rounded-xl border border-gray-200 shadow-sm" }
const _hoisted_44 = { class: "space-y-3" }
const _hoisted_45 = { class: "flex items-center p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_46 = ["checked"]
const _hoisted_47 = { class: "mt-10 hidden md:flex flex-col items-end gap-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_50 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_51 = {
  key: 0,
  class: "text-sm text-red-600 max-w-xl text-right"
}

import { computed, ref, watch } from "vue";
import { DataCard, BaseInput } from "@/components";

import { catalogVisibilityOptions } from "@/data";

import type { GeneralInformationFormData } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountSettingsSection',
  props: {
    formData: {},
    saving: { type: Boolean },
    disableSave: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:formData", "validation-changed", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Afficher/masquer les champs de mot de passe
const showNewPassword = ref(false);
const showConfirmPassword = ref(false);
const newPwdType = computed(() =>
  showNewPassword.value ? "text" : "password",
);
const confirmPwdType = computed(() =>
  showConfirmPassword.value ? "text" : "password",
);

// Validation des mots de passe
const passwordError = computed(() => {
  if (!props.formData.security.changePassword) return "";

  const password = props.formData.security.newPassword;
  if (!password) return "";

  if (password.length < 6) {
    return "Le mot de passe doit contenir au moins 6 caractères";
  }

  return "";
});

// Validation globale - détecte toutes les erreurs
const hasValidationErrors = computed(() => {
  // Erreurs de mots de passe
  const passwordErrors = passwordError.value || confirmPasswordError.value;

  // Erreurs IBAN (format invalide)
  const bankingFormatErrors = ibanHasError.value;

  // Erreurs de champs requis (IBAN et accountTitle obligatoires)
  const requiredFieldsErrors =
    !props.formData.lastName ||
    !props.formData.firstName ||
    !props.formData.email ||
    !props.formData.banking.iban ||
    !props.formData.banking.accountTitle;

  return !!(passwordErrors || bankingFormatErrors || requiredFieldsErrors);
});

const confirmPasswordError = computed(() => {
  if (!props.formData.security.changePassword) return "";

  const password = props.formData.security.newPassword;
  const confirmPassword = props.formData.security.confirmPassword;

  if (!confirmPassword) return "";

  if (password !== confirmPassword) {
    return "Les mots de passe ne correspondent pas";
  }

  return "";
});

// État local pour IBAN
const ibanValue = ref(props.formData.banking.iban);
const ibanHasError = ref(false);
const ibanIsValid = ref(false);
const ibanErrorMessage = ref("");

const accountTitleHasError = ref(false);

// Formatage automatique IBAN avec espaces
const formatIban = (value: string) => {
  const cleanValue = value.replace(/\s/g, "");
  return cleanValue.replace(/(.{4})/g, "$1 ").trim();
};

// Gestion IBAN avec blocage automatique
const handleIbanInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;

  const cleanValue = value.replace(/\s/g, "");

  // Blocage strict : si on a exactement 27 caractères, on ne peut plus taper
  if (cleanValue.length >= 27) {
    const finalFormatted = formatIban(cleanValue.substring(0, 27));
    ibanValue.value = finalFormatted;
    updateFormData("banking.iban", finalFormatted);
    validateIban();
    return;
  }

  // Applique le formatage seulement si on a au moins 4 caractères
  if (cleanValue.length >= 4) {
    const formattedValue = formatIban(value);
    ibanValue.value = formattedValue;
    updateFormData("banking.iban", formattedValue);
  } else {
    ibanValue.value = value;
    updateFormData("banking.iban", value);
  }

  validateIban();
};

// Validation IBAN
const validateIban = () => {
  const value = ibanValue.value.trim();

  if (!value) {
    ibanHasError.value = false;
    ibanIsValid.value = false;
    ibanErrorMessage.value = "";
    return;
  }

  const cleanValue = value.replace(/\s/g, "").toUpperCase();
  const ibanRegex =
      /^FR[0-9]{2}(?: ?[A-Z0-9]{4}){5} ?[A-Z0-9]{3}$/;
      // /^FR[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{4}[A-Z0-9]{3}$/;

  if (cleanValue.length !== 27) {
    ibanHasError.value = true;
    ibanIsValid.value = false;
    ibanErrorMessage.value =
      "Format IBAN invalide. Exemple : FR76 3000 1007 9416 0000 0000 000";
    return;
  }

  if (!ibanRegex.test(cleanValue)) {
    ibanHasError.value = true;
    ibanIsValid.value = false;
    ibanErrorMessage.value =
      "Format IBAN invalide. Exemple : FR76 3000 1007 9416 0000 0000 000";
    return;
  }

  ibanHasError.value = false;
  ibanIsValid.value = true;
  ibanErrorMessage.value = "";
};

// Validation Titulaire du compte
const validateAccountTitle = () => {
  const value = props.formData.banking.accountTitle?.trim();
  if (!value) {
    accountTitleHasError.value = true;
  } else {
    accountTitleHasError.value = false;
  }
};

// Synchronisation avec les props (comme register)
watch(
  () => props.formData.banking.iban,
  (newValue) => {
    ibanValue.value = newValue;
    if (newValue) {
      validateIban();
    }
  },
  { immediate: true },
);

// Watcher pour émettre les changements de validation
watch(
  hasValidationErrors,
  (hasErrors) => {
    emit("validation-changed", hasErrors);
  },
  { immediate: true },
);

const updateFormData = (
  field: string,
  value: string | number | boolean | FileList | null | undefined,
) => {
  const updatedFormData = { ...props.formData };
  const keys = field.split(".");
  let current: Record<string, unknown> = updatedFormData;

  for (let i = 0; i < keys.length - 1; i++) {
    current = current[keys[i]] as Record<string, unknown>;
  }

  // Supprime les caractères invisibles et tout espace dans les emails
  const normalizeEmail = (email: string) =>
    email
      .replace(
        /[\u00A0\u1680\u180E\u2000-\u200D\u2028\u2029\u202F\u205F\u2060\u3000\uFEFF]/g,
        "",
      )
      .replace(/\s+/g, "")
      .trim();

  // Convertir les valeurs undefined en chaînes vides pour les champs texte
  let processedValue = value === undefined ? "" : value;
  if (
    (field === "email" || field === "emailSecondary") &&
    typeof processedValue === "string"
  ) {
    processedValue = normalizeEmail(processedValue);
  }
  current[keys[keys.length - 1]] = processedValue;
  emit("update:formData", updatedFormData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Paramètres du compte",
    icon: "fas fa-user",
    "icon-color": "text-blue-600",
    "icon-bg-color": "bg-blue-100",
    class: "w-full"
  }, {
    "header-actions": _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save'))),
        disabled: _ctx.saving || _ctx.disableSave,
        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
      }, [
        (_ctx.saving)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("i", _hoisted_3)),
        _createElementVNode("span", null, _toDisplayString(_ctx.saving ? "Sauvegarde..." : "Sauvegarder"), 1)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-user text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Informations personnelles ")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateFormData('lastName', $event))),
                label: "Nom",
                type: "text",
                placeholder: "Votre nom",
                required: ""
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.firstName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateFormData('firstName', $event))),
                label: "Prénom",
                type: "text",
                placeholder: "Votre prénom",
                required: ""
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (updateFormData('email', $event))),
                label: "Email",
                type: "email",
                placeholder: "votre@email.com",
                required: ""
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.emailSecondary,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (updateFormData('emailSecondary', $event))),
                label: "Email 2",
                type: "email",
                placeholder: "email@secondaire.com"
              }, null, 8, ["model-value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-shopping-cart text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Informations de commande ")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.minOrder,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (updateFormData('minOrder', $event))),
                label: "Minimum de commande",
                type: "number",
                min: "0",
                step: "0.01"
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.website,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (updateFormData('website', $event))),
                label: "Site web",
                type: "text",
                placeholder: "https://votre-site.com"
              }, null, 8, ["model-value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-share-alt text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Réseaux sociaux")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.socialMedia.facebook,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
                updateFormData('socialMedia.facebook', $event)
              )),
                label: "Facebook",
                type: "text",
                placeholder: "https://facebook.com/votre-page"
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.socialMedia.twitter,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (
                updateFormData('socialMedia.twitter', $event)
              )),
                label: "Twitter",
                type: "text",
                placeholder: "https://twitter.com/votre-compte"
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.socialMedia.instagram,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (
                updateFormData('socialMedia.instagram', $event)
              )),
                label: "Instagram",
                type: "text",
                placeholder: "https://instagram.com/votre-compte"
              }, null, 8, ["model-value"]),
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.socialMedia.tiktok,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (updateFormData('socialMedia.tiktok', $event))),
                label: "TikTok",
                type: "text",
                placeholder: "https://tiktok.com/votre-compte"
              }, null, 8, ["model-value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-university text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Informations bancaires ")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-black" }, [
                  _createTextVNode(" Titulaire du compte "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: "Nom du titulaire du compte",
                    value: _ctx.formData.banking.accountTitle,
                    onInput: _cache[11] || (_cache[11] = ($event: any) => (
                    updateFormData(
                      'banking.accountTitle',
                      ($event.target as HTMLInputElement).value,
                    )
                  )),
                    onBlur: validateAccountTitle,
                    maxlength: 255,
                    class: _normalizeClass(["w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200", 
                    accountTitleHasError.value || !_ctx.formData.banking.accountTitle
                      ? 'border-red-500 bg-red-50'
                      : 'border-gray-300 hover:border-gray-400'
                  ])
                  }, null, 42, _hoisted_16),
                  (!_ctx.formData.banking.accountTitle)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _cache[25] || (_cache[25] = [
                        _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1),
                        _createTextVNode(" Titulaire du compte obligatoire ")
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-black" }, [
                  _createTextVNode(" IBAN "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: "FR76 3000 1007 9416 0000 0000 000",
                    value: ibanValue.value,
                    onInput: handleIbanInput,
                    onBlur: validateIban,
                    maxlength: 35,
                    class: _normalizeClass(["w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200", 
                    ibanHasError.value || !ibanValue.value
                      ? 'border-red-500 bg-red-50'
                      : ibanIsValid.value && ibanValue.value
                      ? 'border-green-500 bg-green-50'
                      : 'border-gray-300 hover:border-gray-400'
                  ])
                  }, null, 42, _hoisted_20),
                  (ibanHasError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(ibanErrorMessage.value), 1)
                      ]))
                    : (!ibanValue.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1),
                          _createTextVNode(" IBAN obligatoire ")
                        ])))
                      : (ibanIsValid.value && ibanValue.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _cache[29] || (_cache[29] = [
                            _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1),
                            _createTextVNode(" Format IBAN valide ")
                          ])))
                        : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-lock text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Gestion du mot de passe ")
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("input", {
                  checked: _ctx.formData.security.changePassword,
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (
                  updateFormData(
                    'security.changePassword',
                    ($event.target as HTMLInputElement).checked,
                  )
                )),
                  type: "checkbox",
                  id: "changePassword",
                  class: "w-4 h-4 text-black bg-gray-100 border-gray-300 rounded focus:ring-gray-500"
                }, null, 40, _hoisted_28),
                _cache[32] || (_cache[32] = _createElementVNode("label", {
                  for: "changePassword",
                  class: "ml-3 text-sm font-medium text-black"
                }, " Changer le mot de passe ", -1))
              ]),
              (_ctx.formData.security.changePassword)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_unref(BaseInput), {
                        "model-value": _ctx.formData.security.newPassword,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (
                    updateFormData('security.newPassword', $event)
                  )),
                        label: "Nouveau mot de passe",
                        type: newPwdType.value,
                        placeholder: "Nouveau mot de passe",
                        error: passwordError.value
                      }, null, 8, ["model-value", "type", "error"]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (showNewPassword.value = !showNewPassword.value)),
                        class: "absolute right-2 top-[20px] h-8 w-8 flex items-center justify-center text-black hover:text-black",
                        "aria-label": 
                    showNewPassword.value
                      ? 'Masquer le mot de passe'
                      : 'Afficher le mot de passe'
                  
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(showNewPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye')
                        }, null, 2)
                      ], 8, _hoisted_31)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(BaseInput), {
                        "model-value": _ctx.formData.security.confirmPassword,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (
                    updateFormData('security.confirmPassword', $event)
                  )),
                        label: "Confirmer mot de passe",
                        type: confirmPwdType.value,
                        placeholder: "Confirmer mot de passe",
                        error: confirmPasswordError.value
                      }, null, 8, ["model-value", "type", "error"]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                        class: "absolute right-2 top-[20px] h-8 w-8 flex items-center justify-center text-black hover:text-black",
                        "aria-label": 
                    showConfirmPassword.value
                      ? 'Masquer le mot de passe'
                      : 'Afficher le mot de passe'
                  
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(
                      showConfirmPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye'
                    )
                        }, null, 2)
                      ], 8, _hoisted_33)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.formData.security.changePassword &&
                (passwordError.value || confirmPasswordError.value)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(passwordError.value || confirmPasswordError.value), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-store text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Statut de la boutique ")
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("input", {
                  checked: _ctx.formData.shop.status === 'online',
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (updateFormData('shop.status', 'online'))),
                  type: "radio",
                  id: "online",
                  value: "online",
                  class: "w-4 h-4 text-black bg-gray-100 border-gray-300 focus:ring-gray-500"
                }, null, 40, _hoisted_38),
                _cache[34] || (_cache[34] = _createElementVNode("label", {
                  for: "online",
                  class: "ml-3 text-sm font-medium text-black"
                }, " En ligne ", -1))
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("input", {
                  checked: _ctx.formData.shop.status === 'offline',
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (updateFormData('shop.status', 'offline'))),
                  type: "radio",
                  id: "offline",
                  value: "offline",
                  class: "w-4 h-4 text-black bg-gray-100 border-gray-300 focus:ring-gray-500"
                }, null, 40, _hoisted_40),
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  for: "offline",
                  class: "ml-3 text-sm font-medium text-black"
                }, " Hors ligne ", -1))
              ]),
              _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-sm text-black italic" }, " Choisissez le statut hors ligne pendant que votre boutique n'est pas prête, ou en cas de modification majeure du catalogue... ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-eye text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Votre catalogue pour les clients non connectés ")
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_unref(BaseInput), {
                "model-value": _ctx.formData.shop.catalogVisibility,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (
                updateFormData('shop.catalogVisibility', $event)
              )),
                label: "",
                type: "select",
                options: _unref(catalogVisibilityOptions),
                class: "w-24"
              }, null, 8, ["model-value", "options"]),
              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-sm text-black" }, "mois", -1))
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-sm text-black mt-3 italic" }, " Vous pouvez désormais choisir à partir de combien de temps (en mois) après leur mise en ligne vos produits seront visibles à tous. Nous vous recommandons fortement d'afficher votre catalogue aux clients non connectés car cela aura pour effet d'optimiser la visibilité de votre marque sur notre site, et d'inciter de nouveaux clients à nous rejoindre. ", -1))
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center" }, [
                _createElementVNode("i", { class: "fas fa-sliders-h text-black text-sm" })
              ]),
              _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Affichage ")
            ], -1)),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("input", {
                  checked: _ctx.formData.shop.showMainColor,
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (
                  updateFormData(
                    'shop.showMainColor',
                    ($event.target as HTMLInputElement).checked,
                  )
                )),
                  type: "checkbox",
                  id: "showMainColor",
                  class: "w-4 h-4 text-black bg-gray-100 border-gray-300 rounded focus:ring-gray-500"
                }, null, 40, _hoisted_46),
                _cache[41] || (_cache[41] = _createElementVNode("label", {
                  for: "showMainColor",
                  class: "ml-3 text-sm font-medium text-black"
                }, " Afficher couleur principale ", -1))
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-sm text-black italic" }, " En cochant cette case, les produits du catalogue, seul les couleurs principal seront visible ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('save'))),
              disabled: _ctx.saving || _ctx.disableSave,
              class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("i", _hoisted_49))
                : (_openBlock(), _createElementBlock("i", _hoisted_50)),
              _createElementVNode("span", null, _toDisplayString(_ctx.saving ? "Sauvegarde..." : "Sauvegarder"), 1)
            ], 8, _hoisted_48),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})